import * as React from 'react';

import * as ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-fox-toast';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { ENV_URL } from './constants';
import './index.css';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';

async function enableMocking(): Promise<any> {
  if (import.meta.env.MODE !== 'development' || import.meta.env.VITE_USE_MOCK !== 'true') {
    return;
  }

  const { worker } = await import('./__mocks__/browser');

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start({
    serviceWorker: {
      url: `${import.meta.env.BASE_URL}mockServiceWorker.js`,
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
enableMocking().then(() =>
  root.render(
    <React.StrictMode>
      <ToastContainer />
      <BrowserRouter basename={ENV_URL}>
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
    </React.StrictMode>
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
